var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Modelos","storeName":"Car_models","parentStoreName":"Car_brands","parentUrlKey":"brand_id","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"labelBack":"Atrás","sortable":"","breadcrumbs":[
    {
      text: 'Spots y vehículos',
      disabled: false,
      href: '/admin/cars'
    },
    {
      text: 'Modelos',
      disabled: false,
      href: '#'
    },
  ]},scopedSlots:_vm._u([{key:"car_picture",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{attrs:{"src":item.car_picture,"alt":"","width":"150"}})])],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }